import {Link} from 'gatsby'
import React from 'react'
import { cn, getPageUrl } from '../lib/helpers'


function DynamicZoneComponent ({component}) {
  
  console.log(component.__typename)
  if (component.__typename == "STRAPI_ComponentContentListTopN"){
    return (
        <div>
            <Link to={getPageUrl(component.page)}>
                <h2>{component.page.title}</h2>
            </Link>
            <p>{component.description}</p>
        </div>
      )
  }
  if (component.__typename == "STRAPI_ComponentContentEmbeddedHtml"){
    return (
        <div dangerouslySetInnerHTML={{__html: component.raw_html }} />
    )
  }
  return (
    <div>
        <h2>{component.__typename}</h2>
    </div>
  )
}

DynamicZoneComponent.defaultProps = {
    props: {},
  }

export default DynamicZoneComponent
